/* global WP, window */
import GoogleMaps from './GoogleMaps'
import $ from 'jquery'

const styles = [
    {
        'featureType': 'water',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#d3d3d3'
            }
        ]
    },
    {
        'featureType': 'transit',
        'stylers': [
            {
                'color': '#808080'
            },
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'road.highway',
        'elementType': 'geometry.stroke',
        'stylers': [
            {
                'visibility': 'on'
            },
            {
                'color': '#b3b3b3'
            }
        ]
    },
    {
        'featureType': 'road.highway',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#ffffff'
            }
        ]
    },
    {
        'featureType': 'road.local',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'visibility': 'on'
            },
            {
                'color': '#ffffff'
            },
            {
                'weight': 1.8
            }
        ]
    },
    {
        'featureType': 'road.local',
        'elementType': 'geometry.stroke',
        'stylers': [
            {
                'color': '#d7d7d7'
            }
        ]
    },
    {
        'featureType': 'poi',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'visibility': 'on'
            },
            {
                'color': '#ebebeb'
            }
        ]
    },
    {
        'featureType': 'administrative',
        'elementType': 'geometry',
        'stylers': [
            {
                'color': '#a7a7a7'
            }
        ]
    },
    {
        'featureType': 'road.arterial',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#ffffff'
            }
        ]
    },
    {
        'featureType': 'road.arterial',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#ffffff'
            }
        ]
    },
    {
        'featureType': 'landscape',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'visibility': 'on'
            },
            {
                'color': '#efefef'
            }
        ]
    },
    {
        'featureType': 'road',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'color': '#696969'
            }
        ]
    },
    {
        'featureType': 'administrative',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'visibility': 'on'
            },
            {
                'color': '#737373'
            }
        ]
    },
    {
        'featureType': 'poi',
        'elementType': 'labels.icon',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'poi',
        'elementType': 'labels',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'road.arterial',
        'elementType': 'geometry.stroke',
        'stylers': [
            {
                'color': '#d6d6d6'
            }
        ]
    },
    {
        'featureType': 'road',
        'elementType': 'labels.icon',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {},
    {
        'featureType': 'poi',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#dadada'
            }
        ]
    }
]

const init = ($mapContainer, center = {lat: 0, lng: 0}, markers = []) => {

    const eventBus = $({});

    window.initializeGoogleMaps = function () {

        const map = new GoogleMaps($mapContainer, {
            scrollwheel: false,
            zoom: 6
        })

        map
            .init()
            .setStyles(styles)
            .centerMap(center)

        markers.forEach(({lat, lng}) => {
            const marker = map.addMarker({
                position: {
                    lat: parseFloat(lat),
                    lng: parseFloat(lng),
                },
                icon: `${WP.templateDirectory}/dist/img/map-pin.png`,
            });

            marker.addListener('mouseover', ({ latLng }) => {
                eventBus.trigger('mouseOver', [{
                    lat: latLng.lat(),
                    lng: latLng.lng(),
                }])
            });

            marker.addListener('mouseout', ({ latLng }) => {
                eventBus.trigger('mouseOut', [{
                    lat: latLng.lat(),
                    lng: latLng.lng(),
                }])
            })
        })

    }

    $.getScript(`https://maps.googleapis.com/maps/api/js?key=${WP.apis.googleMaps}&callback=window.initializeGoogleMaps`);

    return eventBus;
}

export default init



// WEBPACK FOOTER //
// ./src/js/modules/map.js